import { apiUrl } from "../../utils/url";
import { HttpClient, HttpError } from "../HttpClient";
import { toServiceError } from "../errors";
import {
  IRuleServiceDurationService,
  RuleServiceDurationRequest,
  RuleServiceDurationResponse,
} from "./IRuleServiceDurationService";

export class RuleServiceDurationService implements IRuleServiceDurationService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async calculateServiceDuration(
    data: RuleServiceDurationRequest,
  ): Promise<RuleServiceDurationResponse> {
    try {
      const response = await this.httpClient.post<RuleServiceDurationResponse>(
        "/ruleServiceDuration/calculate",
        data,
      );

      return response;
    } catch (error) {
      // useServiceDuration reads the error code from the HttpError itself.
      if (error instanceof HttpError) throw error;

      throw toServiceError(
        error,
        "Não foi possível calcular a duração do serviço. Confirme o serviço e o perfil do animal.",
      );
    }
  }
}
